module.exports = "/_next/static/public/images/bc71cf55c6f43cb960463fff82aaf090-ac331b18587a0d196ec4cdbbe4f54ef1.png";